import { useTranslation } from 'react-i18next';
import StepContainer from '../../components/onboarding/StepContainer';
import { useOnboardingStore } from '../../stores/onboardingStore';

export default function WelcomeStep() {
  const { t } = useTranslation();
  const { nextStep } = useOnboardingStore();

  return (
    <StepContainer
      title={t('onboarding.welcome.title')}
      description={t('onboarding.welcome.subtitle')}
      onNext={nextStep}
      nextLabel={t('onboarding.welcome.start')}
    >
      <div className="space-y-6">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <img
            src="/logo.png"
            alt="Growe.io"
            className="h-32 dark:hidden"
          />
          <img
            src="/logo-white.png"
            alt="Growe.io"
            className="h-32 hidden dark:block"
          />
        </div>

        {/* Features */}
        <div className="space-y-4">
          {[
            {
              icon: '🚀',
              title: t('onboarding.welcome.feature1Title'),
              description: t('onboarding.welcome.feature1Desc'),
            },
            {
              icon: '🎨',
              title: t('onboarding.welcome.feature2Title'),
              description: t('onboarding.welcome.feature2Desc'),
            },
            {
              icon: '📊',
              title: t('onboarding.welcome.feature3Title'),
              description: t('onboarding.welcome.feature3Desc'),
            },
          ].map((feature, index) => (
            <div
              key={index}
              className="flex items-start gap-4 p-4 border-2 border-gray-200 dark:border-gray-700 rounded-lg"
            >
              <div className="text-3xl">{feature.icon}</div>
              <div>
                <h3 className="font-bold text-lg mb-1 dark:text-gray-100">
                  {feature.title}
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </StepContainer>
  );
}
